import React, { Component } from 'react';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';
import { Icon } from 'antd';
import moment from 'moment';

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
            },
            data: [],
            datakp:[]
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams,searchChange } = this.props;
        const{year}=searchParams;
        // let beginDate = moment(`${moment().format('YYYY')}-1`).format('YYYY-MM');
        // let endDate = moment(`${moment().format('YYYY')}-12`).format('YYYY-MM');
        // beginDate=moment(`${moment(year).format('YYYY')}-1`).format('YYYY-MM');
        // endDate=moment(`${moment(year).format('YYYY')}-12`).format('YYYY-MM');
        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryInvoicingList, {
            // offset: current,
            // limit: pageSize,
            // beginDate:beginDate,
            // endDate:endDate,
            year:year?year:moment().format('YYYY'),
            ...searchParams,
        }).then(res => {
            const { list,kp_list,totalCount } = res;
            //pagination.total = totalCount;
            this.setState({
                //pagination,
                data: list,
                datakp: kp_list,
                loading: false,
            });
            searchChange(searchParams);
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getDOm = (count) => {
        let dom = <i style={{ display: 'inline-block', width: 12, height: 12 }}></i>;
        if (count > 0) {
            dom = <Icon style={{ color:'#F00', fontSize: "6px" }} type="caret-up" />;
        } else if (count < 0) {
            dom = <Icon style={{ color:'#0F0', fontSize: "6px" }} type="caret-down" />;
        } else if ((!count) || (count === 0)) {
            dom = null;
        }
        return dom;
    }

    getColumns = (type) => {
        const columns = [{
            title: type=="all"?'累计开票金额':"开票确认收入的开票金额",
            dataIndex: 'title',
            key: 'title',
            width: 220,
            fixed:"left"
        },{
            title: '全年合计',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            width: 130,
            fixed:"left",
            render: (text, record) => {
                    return(
                    <span style={{fontWeight:"bold"}}>
                      {
                      (type=="all"&&(record.title&&record.title.indexOf("环比金额提高百分比") != -1))
                      ?"-":
                      (record.totalAmount?record.totalAmount:"0")
                      }
                    </span>
                    )     
            },
        },{
            title: '1月',
            dataIndex: 'januaryAmount',
            key: 'januaryAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.januaryAmount);
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                           <span style={
                               record.januaryAmount>0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                               (record.januaryAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{
                               (type=="all"&&(record.title&&record.title.indexOf("环比金额提高百分比") != -1))?
                               "-":
                               record.januaryAmount?`${Math.abs(record.januaryAmount)}%`:"0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                      {record.januaryAmount?record.januaryAmount:"0"}
                    </span>
                    )     
                }
            },
        },{
            title: '2月',
            dataIndex: 'februaryAmount',
            key: 'februaryAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.februaryAmount);
                    return (
                        <span  style={{display:"flex",lineHeight:1}}>
                             <span style={record.februaryAmount>0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                              (record.februaryAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.februaryAmount?`${Math.abs(record.februaryAmount)}%`:"0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                    {record.februaryAmount?record.februaryAmount:"0"}
                  </span>
                    )   
                }
            },
        },{
            title: '3月',
            dataIndex: 'marchAmount',
            key: 'marchAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.marchAmount);
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                            <span style={
                                record.marchAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.marchAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )}>{record.marchAmount?`${Math.abs(record.marchAmount)}%`:"0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                           {record.marchAmount?record.marchAmount:"0"}
                    </span>
                    )       
                }
            },
        },{
            title: '4月',
            dataIndex: 'aprilAmount',
            key: 'aprilAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.aprilAmount);
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={ 
                                 record.aprilAmount>0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.aprilAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.aprilAmount?`${Math.abs(record.aprilAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                    {record.aprilAmount?record.aprilAmount:"0"}
                    </span>
                    )
                }
            },
        },{
            title: '5月',
            dataIndex: 'mayAmount',
            key: 'mayAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.mayAmount);
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={ 
                               record.mayAmount>0? 
                               {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.mayAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.mayAmount?`${Math.abs(record.mayAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.mayAmount?record.mayAmount:"0"}
                    </span>
                    )     
                }
            },
        },{
            title: '6月',
            dataIndex: 'juneAmount',
            key: 'juneAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.juneAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={
                                 record.juneAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.juneAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.juneAmount?`${Math.abs(record.juneAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                    {record.juneAmount?record.juneAmount:"0"}
                    </span>
                    )
                }
            },
        },{
            title: '7月',
            dataIndex: 'julyAmount',
            key: 'julyAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.julyAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={ 
                                 record.julyAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.julyAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.julyAmount?`${Math.abs(record.julyAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                    {record.julyAmount?record.julyAmount:"0"}
                    </span>
                    ) 
                }
            },
        },{
            title: '8月',
            dataIndex: 'augustAmount',
            key: 'augustAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.augustAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={
                                 record.augustAmount>0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.augustAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )}
                               >{record.augustAmount?`${Math.abs(record.augustAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.augustAmount?record.augustAmount:"0"}
                    </span>
                    )    
                }
            },
        },{
            title: '9月',
            dataIndex: 'septemberAmount',
            key: 'septemberAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.septemberAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={
                                 record.septemberAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.septemberAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )}>{record.septemberAmount?`${Math.abs(record.septemberAmount)}%`:"0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.septemberAmount?record.septemberAmount:"0"}
                    </span>
                    )    
                }
            },
        },{
            title: '10月',
            dataIndex: 'octoberAmount',
            key: 'octoberAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.octoberAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={
                                 record.octoberAmount>0? 
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.octoberAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )
                               }>{record.octoberAmount?`${Math.abs(record.octoberAmount)}%`:"0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.octoberAmount?record.octoberAmount:"0"}
                    </span>
                    )  
                }
            },
        },{
            title: '11月',
            dataIndex: 'novemberAmount',
            key: 'novemberAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.novemberAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={ 
                                 record.novemberAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.novemberAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )}>{record.novemberAmount?`${Math.abs(record.novemberAmount)}%`: "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.novemberAmount?record.novemberAmount:"0"}
                    </span>
                    )    
                }
            },
        },{
            title: '12月',
            dataIndex: 'decemberAmount',
            key: 'decemberAmount',
            width: 130,
            render: (text, record) => {
                if(record.title&&record.title.indexOf("百分比") != -1){
                    const momthSymbol = this.getDOm(record.decemberAmount); 
                    return (
                        <span style={{display:"flex",lineHeight:1}}>
                             <span style={
                                 record.decemberAmount>0?
                                {width:"75px",display:"block",fontWeight:"bold",color:'#F00'}:
                                (record.decemberAmount<0?
                               {width:"75px",display:"block",fontWeight:"bold",color:'#0F0'}
                               :
                               {width:"75px",display:"block",fontWeight:"bold"}
                               )}>{record.decemberAmount?`${Math.abs(record.decemberAmount)}%` : "0"}</span>&nbsp;&nbsp;&nbsp;&nbsp;{momthSymbol}
                        </span>
                    );
                }else{
                    return(
                    <span>
                        {record.decemberAmount?record.decemberAmount:"0"}
                    </span>
                    )    
                }
            },
        },
    
    ];
        return columns;
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data,datakp, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    // pagination={pagination}
                    pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns("all")}
                    className="unregisterRequest"
                />

                <TableC //开票确认收入的开票金额
                    data={datakp}
                    scrollY={height}
                    loading={loading}
                    // pagination={pagination}
                    pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns("kp")}
                    className="kpTable"
                />
                
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualBillingAnalysis/TablePage/List.js